export const localeObjectSerbianDayjs = (t: any) => ({
  weekdaysMin: [
    t("ANTD.NED"),
    t("ANTD.PON"),
    t("ANTD.UTO"),
    t("ANTD.SRE"),
    t("ANTD.CET"),
    t("ANTD.PET"),
    t("ANTD.SUB"),
  ],
  monthsShort: [
    t("ANTD.JAN"),
    t("ANTD.FEB"),
    t("ANTD.MAR"),
    t("ANTD.APR"),
    t("ANTD.MAJ"),
    t("ANTD.JUN"),
    t("ANTD.JUL"),
    t("ANTD.AVG"),
    t("ANTD.SEP"),
    t("ANTD.OKT"),
    t("ANTD.NOV"),
    t("ANTD.DEC"),
  ],
  weekStart: 1,
});
